import React from "react";

function AdminFooter() {
  return (
    <footer className="bg-white w-full p-4 shadow-md">
      <h5 className="text-center text-sm font-bold">
        Imdady R3 - Restaurant Management System @ 2025 Version 2.0.0
      </h5>
    </footer>
  );
}

export default AdminFooter;
